var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container px-0", attrs: { id: "tabs-navigation" } },
    [
      _c(
        "nav",
        {
          staticClass:
            "ob1-menu-page ob1-menu-page-fullscreen ob1-menu-page-icon h-auto",
        },
        [
          _c(
            "ul",
            { staticClass: "nav ob1-nav-light" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "nav-item",
                  class: tab.id,
                  attrs: { "data-test-id": "tab-" + index },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        "data-oevent-category": tab.tmsButton.category,
                        "data-oevent-action": tab.tmsButton.action,
                        "data-oevent-label": tab.tmsButton.label,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeSelectedTab(tab.id)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "item-icon",
                        class: tab.icon,
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(_vm._s(tab.label) + "\n                "),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }